import * as React from "react";
import * as _ from "lodash";
import { SimpleBarChart } from "../../../../core/Chart";
import { FlyerItem } from "../../../../core/Chart/Heatmap/types";
import {
  formatYAxisLabel,
  formatXAxisLabel,
  defaultYTickProps,
  defaultXTickProps,
  defaultYLabelProps,
  defaultXLabelProps
} from "../../../constants";

interface PageLevelBarChartProps {
  metric: string;
  items: FlyerItem[];
  handleBarClick: (data: any, index: number) => void;
}

export class PageLevelBarChart extends React.Component<
  PageLevelBarChartProps,
  {}
> {
  groupItemsByPage = (metric: string) => {
    const data: any = [];
    this.props.items.forEach((item: FlyerItem) => {
      // If data entry for this items page doesn't exist, create it
      if (!data[item.orig_flyer_item_page_position]) {
        const entry: any = {};
        entry.page = item.orig_flyer_item_page_position;
        entry[metric] = 0;
        data[item.orig_flyer_item_page_position] = entry;
      }
      data[item.orig_flyer_item_page_position][metric] += item[metric];
    });

    return data.filter((item: any) => item !== undefined);
  };

  formatTitle = (metric: string) => {
    const suffix = " PER PAGE";
    const formattedMetric = _.upperCase(metric.split("_").join(" "));
    return formattedMetric + suffix;
  };

  render() {
    const metric =
      this.props.metric == "item_views" ? "views" : this.props.metric;
    return (
      <div>
        {this.props.items.length > 0 && (
          <div>
            <div
              style={{ textAlign: "center", fontSize: 14, color: "#5d6368" }}
            >
              {this.formatTitle(this.props.metric)}
            </div>
            <SimpleBarChart
              containerProps={{
                height: 350,
                width: "98%"
              }}
              chartProps={{
                data: this.groupItemsByPage(metric),
                valueKey: this.props.metric,
                groupingKey: "page"
              }}
              yAxisProps={{
                labelProps: defaultYLabelProps(this.props.metric),
                tickProps: defaultYTickProps
              }}
              xAxisProps={{
                labelProps: defaultXLabelProps("Page"),
                tickProps: defaultXTickProps
              }}
              handleBarClick={this.props.handleBarClick}
              disableBrush={true}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/PageLevelBarChart/index.tsx